__turbopack_context__.v({
  "myTasksSubRowForm": "dEnR5q_myTasksSubRowForm",
  "myTasksSubRowForm__assignee": "dEnR5q_myTasksSubRowForm__assignee",
  "myTasksSubRowForm__dataBadge": "dEnR5q_myTasksSubRowForm__dataBadge",
  "myTasksSubRowForm__description": "dEnR5q_myTasksSubRowForm__description",
  "myTasksSubRowForm__detail": "dEnR5q_myTasksSubRowForm__detail",
  "myTasksSubRowForm__details": "dEnR5q_myTasksSubRowForm__details",
  "myTasksSubRowForm__footer": "dEnR5q_myTasksSubRowForm__footer",
  "myTasksSubRowForm__label": "dEnR5q_myTasksSubRowForm__label",
  "myTasksSubRowForm__meterStack": "dEnR5q_myTasksSubRowForm__meterStack",
  "myTasksSubRowForm__muted": "dEnR5q_myTasksSubRowForm__muted",
  "myTasksSubRowForm__status": "dEnR5q_myTasksSubRowForm__status",
});
